import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  selectedSTOperationSharedUid: "", // selected site shared_uid
  selectedSTOperationAccount: "", // selected accout shared_uid
  accountsForSTOperation: [], // All accounts data
  scopesOfSTOperation: [], // Scopes data
  campaignsWithoutScopeData: [], // Campaigns Without Scopes
  negativesInListAndInAdGroupData: [], //2nd table data
  negativesInTheCampaignData: [], // 3rd table data
  isScopesLoading: false,
  isScopesTabDataFetched: false, //checking is Data is fetched or not
  sortForScopesData: {
    keytoSort: "modified",
    direction: "desc",
  }, // Sorting for Scopes
  sortCampaignsWithoutScopeData: {
    keytoSort: "modified",
    direction: "desc",
  }, // sorting for Campaigns Without Scopes
  selectedNegativeSearchTerm: "", // filter serach term (2nd table)
  selectedCampaigns: [], // selected campaigns (2nd table)
  selectedAdgroups: [], // selected adgroups (2nd table)
  selectedRowsForNegatives: [], // selected rows in 2nd table
  openBulkActionModal: false, // open bulk action modal(2nd table)
  singleRowIDPassToModal: "", // when single row is selected pass row id (2nd table)

  selectedNegativeSearchTermForCampaign: "", // filter search term (3rd table)
  selectedCampaignsForCampaign: [], // selected campaigns (3rd table)
  selectedAdgroupsForCampaign: [], // selected adgroups (3rd table)
  selectedRowsForNegativesCampaign: [], // selected rows in 3rd table
  openBulkActionModalForCampaign: false, // open bulk action modal (3rd table)
  singleRowIDPassToModalForCampaign: "", // when single row is selected pass row id (3rd table)
  openMoveAnotherCampaignModal: false, // open move another campaign modal (3rd table)
  newScopeLoading: false, // loading state for creating new scope
  removeNegativeLoadingForBothLoading: false, // loading state for removing search term(2nd table)
  removeNegativeLoadingCampaignLoading: false, // loading state for removing search term(3rd table)
  campaignToScopeLoading: false, // loading state for moving campaign to scope linking from 1st table(Campaign without scope)
  selectedSingleScopeID: "", // when edit the single scope, pass the scope id
  editScopeLoading: false, // loading state for edit scope

  page: 0,
  rowsPerPage: 10,
  sort: {
    keytoSort: "search_term",
    direction: "desc",
  },
};

const scopeTabSlice = createSlice({
  name: "scopeTab",
  initialState,
  reducers: {
    setSelectedSTOperationSharedUid: (state, action) => {
      state.selectedSTOperationSharedUid = action.payload;
    },
    setSelectedSTOperationAccount: (state, action) => {
      state.selectedSTOperationAccount = action.payload;
    },
    setAccountsForSTOperation: (state, action) => {
      state.accountsForSTOperation = action.payload;
    },
    setScopesOfSTOperation: (state, action) => {
      state.scopesOfSTOperation = action.payload;
    },
    setCampaignsWithoutScopeData: (state, action) => {
      state.campaignsWithoutScopeData = action.payload;
    },
    setNegativesInListAndInAdGroupData: (state, action) => {
      state.negativesInListAndInAdGroupData = action.payload;
    },
    setNegativesInTheCampaignData: (state, action) => {
      state.negativesInTheCampaignData = action.payload;
    },
    setIsScopesLoading: (state, action) => {
      state.isScopesLoading = action.payload;
    },
    setIsScopesTabDataFetched: (state, action) => {
      state.isScopesTabDataFetched = action.payload;
    },
    setSortForScopesData: (state, action) => {
      state.sortForScopesData = action.payload;
    },
    setSortCampaignsWithoutScopeData: (state, action) => {
      state.sortCampaignsWithoutScopeData = action.payload;
    },
    setSelectedNegativeSearchTerm: (state, action) => {
      state.selectedNegativeSearchTerm = action.payload;
    },
    setSelectedCampaigns: (state, action) => {
      state.selectedCampaigns = action.payload;
    },
    setSelectedAdgroups: (state, action) => {
      state.selectedAdgroups = action.payload;
    },
    setSelectedRowsForNegatives: (state, action) => {
      state.selectedRowsForNegatives = action.payload;
    },
    setOpenBulkActionModal: (state, action) => {
      state.openBulkActionModal = action.payload;
    },
    setSingleRowIDPassToModal: (state, action) => {
      state.singleRowIDPassToModal = action.payload;
    },
    setSelectedNegativeSearchTermForCampaign: (state, action) => {
      state.selectedNegativeSearchTermForCampaign = action.payload;
    },
    setSelectedCampaignsForCampaign: (state, action) => {
      state.selectedCampaignsForCampaign = action.payload;
    },
    setSelectedAdgroupsForCampaign: (state, action) => {
      state.selectedAdgroupsForCampaign = action.payload;
    },
    setSelectedRowsForNegativesCampaign: (state, action) => {
      state.selectedRowsForNegativesCampaign = action.payload;
    },
    setOpenBulkActionModalForCampaign: (state, action) => {
      state.openBulkActionModalForCampaign = action.payload;
    },
    setSingleRowIDPassToModalForCampaign: (state, action) => {
      state.singleRowIDPassToModalForCampaign = action.payload;
    },
    setOpenMoveAnotherCampaignModal: (state, action) => {
      state.openMoveAnotherCampaignModal = action.payload;
    },
    setNewScopeLoading: (state, action) => {
      state.newScopeLoading = action.payload;
    },
    setRemoveNegativeLoadingForBothLoading: (state, action) => {
      state.removeNegativeLoadingForBothLoading = action.payload;
    },
    setRemoveNegativeLoadingCampaignLoading: (state, action) => {
      state.removeNegativeLoadingCampaignLoading = action.payload;
    },
    setCampaignToScopeLoading: (state, action) => {
      state.campaignToScopeLoading = action.payload;
    },
    setSelectedSingleScopeID: (state, action) => {
      state.selectedSingleScopeID = action.payload;
    },
    setEditScopeLoading: (state, action) => {
      state.editScopeLoading = action.payload;
    },

    setSort: (state, action) => {
      state.sort = action.payload;
    },
    setPage: (state, action) => {
      state.page = action.payload;
    },
    setRowsPerPage: (state, action) => {
      state.rowsPerPage = action.payload;
    },
    // Reset filters and selections for 2nd table (Negatives In List And In AdGroup)
    resetNegativesInAdGroupTableFilters: (state) => {
      state.selectedNegativeSearchTerm = ""; //filter reset
      state.selectedCampaigns = []; //filter reset
      state.selectedAdgroups = []; //filter reset
      state.selectedRowsForNegatives = []; // selected rows reset

      state.openBulkActionModal = false; // close bulk action modal
      state.singleRowIDPassToModal = ""; // clear single row id passed to modal

      // Reset pagination and sorting

      state.page = 0;
      state.rowsPerPage = 10;
      state.sort = {
        keytoSort: "search_term",
        direction: "desc",
      };
    },
    // Reset filters and selections for 3rd table (Negatives In The Campaign)
    resetNegativesInCampaignTableFilters: (state) => {
      state.selectedNegativeSearchTermForCampaign = ""; //filter reset
      state.selectedCampaignsForCampaign = []; //filter reset
      state.selectedAdgroupsForCampaign = []; //filter reset
      state.selectedRowsForNegativesCampaign = []; // selected rows reset

      state.openBulkActionModalForCampaign = false;
      state.openMoveAnotherCampaignModal = false;
      state.singleRowIDPassToModalForCampaign = "";

      state.page = 0;
      state.rowsPerPage = 10;
      state.sort = {
        keytoSort: "search_term",
        direction: "desc",
      };
    },

    // Add granular reset for filters and modals only (preserve data and settings)
    resetScopesTabFiltersAndModals: (state) => {
      // Reset 2nd table filters
      state.selectedNegativeSearchTerm = "";
      state.selectedCampaigns = [];
      state.selectedAdgroups = [];
      state.selectedRowsForNegatives = [];

      // Reset 3rd table filters
      state.selectedNegativeSearchTermForCampaign = "";
      state.selectedCampaignsForCampaign = [];
      state.selectedAdgroupsForCampaign = [];
      state.selectedRowsForNegativesCampaign = [];

      // Reset all modals
      state.openBulkActionModal = false;
      state.openBulkActionModalForCampaign = false;
      state.openMoveAnotherCampaignModal = false;
      state.singleRowIDPassToModal = "";
      state.singleRowIDPassToModalForCampaign = "";

      // Reset loading state
      state.isScopesLoading = false;
      state.newScopeLoading = false; // loading state for creating new scope
      state.removeNegativeLoadingForBothLoading = false; // loading state for removing search term(2nd table)
      state.removeNegativeLoadingCampaignLoading = false; // loading state for removing search term(3rd table)
      state.campaignToScopeLoading = false; // loading state for moving campaign to scope linking from 1st table(Campaign without scope) // when edit the single scope, pass the scope id
      state.editScopeLoading = false;

      // Reset pagination and sorting for tables
      state.page = 0;
      state.rowsPerPage = 10;
      state.sort = {
        keytoSort: "search_term",
        direction: "desc",
      };
    },
    resetStateOfScopesTab: () => initialState, // reset everything for STO scopes tab
  },
});

export const {
  setSelectedSTOperationSharedUid,
  setSelectedSTOperationAccount,
  setAccountsForSTOperation,
  setScopesOfSTOperation,
  setCampaignsWithoutScopeData,
  setNegativesInListAndInAdGroupData,
  setNegativesInTheCampaignData,
  setIsScopesLoading,
  setIsScopesTabDataFetched,
  setSortForScopesData,
  setSortCampaignsWithoutScopeData,
  setSelectedNegativeSearchTerm,
  setSelectedCampaigns,
  setSelectedAdgroups,
  setSelectedRowsForNegatives,
  setOpenBulkActionModal,
  setSingleRowIDPassToModal,
  setSelectedNegativeSearchTermForCampaign,
  setSelectedCampaignsForCampaign,
  setSelectedAdgroupsForCampaign,
  setSelectedRowsForNegativesCampaign,
  setOpenBulkActionModalForCampaign,
  setSingleRowIDPassToModalForCampaign,
  setOpenMoveAnotherCampaignModal,
  setNewScopeLoading,
  setRemoveNegativeLoadingForBothLoading,
  setRemoveNegativeLoadingCampaignLoading,
  setCampaignToScopeLoading,
  setSelectedSingleScopeID,
  setEditScopeLoading,
  setSort,
  setPage,
  setRowsPerPage,
  resetNegativesInAdGroupTableFilters,
  resetNegativesInCampaignTableFilters,
  resetScopesTabFiltersAndModals,
  resetStateOfScopesTab,
} = scopeTabSlice.actions;

export default scopeTabSlice.reducer;
